import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const comparisonRows = [{
  without: '❌ Arriving without a real plan',
  with: '✅ 10 min/week. Everything ready.'
}, {
  without: '❌ Searching for new drills online',
  with: '✅ 101 drills + 6 volumes by level'
}, {
  without: '❌ Skill levels varying wildly',
  with: '✅ Logical, measurable progression'
}, {
  without: '❌ Sessions feeling improvised',
  with: '✅ Evaluation sheets and progress tracking'
}];
const offer = {
  emoji: '🏆',
  title: 'NETBALL READY 360 + TACTICAL PLAYBOOK PRO',
  description: '6 Volumes + 5 Bonuses + Pro Tactical Kit',
  originalPrice: '$90',
  price: '$27',
  ctaText: '🚀 I WANT NETBALL READY NOW',
  ctaHref: 'https://basket-pronto.impultienda.ar/checkout',
  savings: 'SAVE $63'
};
export function FinalCTA() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-58">
      <div className="max-w-2xl mx-auto" data-id="element-59">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white text-center mb-8 tracking-tight leading-tight" data-id="element-60">
          Your next training session can keep being improvised.{' '}
          <br className="hidden md:block" data-id="element-61" />
          <span className="text-[#6B2FB3]" data-id="element-62">
            OR you can finally have a real system.
          </span>
        </h2>

        <p className="text-[#B0B0C0] text-center text-base sm:text-lg font-medium mb-12 max-w-xl mx-auto" data-id="element-63">
          Join hundreds of coaches worldwide who already plan their entire
          season in under 5 minutes.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-white font-bold text-sm sm:text-base mb-12 uppercase tracking-wider" data-id="element-64">
          <span data-id="element-65">Sessions.</span>
          <span className="text-[#333]" data-id="element-66">/</span>
          <span data-id="element-67">Drills.</span>
          <span className="text-[#333]" data-id="element-68">/</span>
          <span data-id="element-69">Progressions.</span>
          <span className="text-[#333]" data-id="element-70">/</span>
          <span data-id="element-71">Management.</span>
          <span className="text-[#333]" data-id="element-72">/</span>
          <span className="text-[#00C853]" data-id="element-73">All organized.</span>
        </div>

        <div className="bg-[#16161F] border border-[#6B2FB333] rounded-2xl overflow-hidden mb-12 shadow-2xl" data-id="element-74">
          <div className="grid grid-cols-2 bg-[#0A0A0A] border-b border-[#6B2FB333]" data-id="element-75">
            <div className="px-4 py-4 font-black text-[#B0B0C0] text-xs sm:text-sm text-center uppercase tracking-wider" data-id="element-76">
              Without Netball Ready 360
            </div>
            <div className="px-4 py-4 font-black text-[#6B2FB3] text-xs sm:text-sm text-center border-l border-[#6B2FB333] uppercase tracking-wider" data-id="element-77">
              With Netball Ready 360
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-[#6B2FB333]' : ''}`} data-id="element-78">
              <div className="px-4 py-4 text-[#B0B0C0] text-xs sm:text-sm font-medium" data-id="element-79">
                {row.without}
              </div>
              <div className="px-4 py-4 text-white font-bold text-xs sm:text-sm bg-[#6B2FB3]/5 border-l border-[#6B2FB333]" data-id="element-80">
                {row.with}
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8" data-id="element-81">
          <CountdownTimer size="md" blinking={true} data-id="element-82" />
        </div>

        <div className="max-w-xl mx-auto mb-8" data-id="element-83">
          <div className="relative bg-[#16161F] border-2 border-[#6B2FB3] rounded-2xl p-6 shadow-[0_0_40px_rgba(107,47,179,0.15)] overflow-hidden" data-id="element-84">
            <div className="absolute top-0 right-0 bg-[#6B2FB3] text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-85">
              🏆 COMPLETE PACKAGE
            </div>

            <div className="flex items-center gap-2 mb-2 mt-3 sm:mt-0" data-id="element-86">
              <span className="text-xl" data-id="element-87">{offer.emoji}</span>
              <span className="text-white font-black text-base sm:text-lg tracking-tight" data-id="element-88">
                {offer.title}
              </span>
            </div>
            <p className="text-[#B0B0C0] text-sm font-medium mb-5" data-id="element-89">
              {offer.description}
            </p>

            <div className="flex items-end justify-between" data-id="element-90">
              <div data-id="element-91">
                <div className="text-[#B0B0C0] line-through text-sm font-bold mb-1" data-id="element-92">
                  {offer.originalPrice}
                </div>
                <div className="font-black text-4xl sm:text-5xl text-white tracking-tighter leading-none" data-id="element-93">
                  {offer.price}
                </div>
              </div>
              <span className="inline-block bg-[#00C853]/15 text-[#00C853] text-xs font-black px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-94">
                {offer.savings}
              </span>
            </div>
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-95">
          <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-2xl py-6 rounded-2xl transition-colors shadow-2xl mb-6" data-id="element-96">
            {offer.ctaText}
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#B0B0C0] font-bold" data-id="element-97">
            <span className="flex items-center gap-1.5" data-id="element-98">🔒 Secure Payment</span>
            <span className="flex items-center gap-1.5" data-id="element-99">⚡ Instant Access</span>
            <span className="flex items-center gap-1.5" data-id="element-100">
              🛡️ 7-Day Guarantee
            </span>
            <span className="flex items-center gap-1.5" data-id="element-101">
              💳 Card · GooglePay · ApplePay
            </span>
          </div>
        </div>
      </div>
    </section>;
}